// Mirror of the site's resx convention: the English text IS the key and a
// key without a translation falls back to English. The translations live only in
// Client/Resources/SharedResources.{lang}.resx; _Layout injects the current
// language's into window.__i18n (for "en" nothing is injected and t returns the key).
// We cache the translation table once when the module loads
const isBrowser = typeof window !== "undefined";
const i18nTable = (isBrowser && window.__i18n) || null;

export function currentLanguage() {
    return (typeof document !== "undefined" && document.documentElement.lang || "en").toLowerCase();
}

export function t(key, ...args) {
    // 1. Look up the translation (O(1) time)
    const text = (i18nTable && i18nTable[key]) || key;

    // 2. If there are no arguments to replace, we finish immediately
    if (args.length === 0) return text;

    // 3. Replace in a single pass using RegEx
    // Matches anything in the {number} format and replaces it with the indexed argument
    return text.replace(/\{(\d+)\}/g, (match, index) => {
        const value = args[index];
        return value !== undefined ? String(value) : match;
    });
}